import { PropController } from "../prop-controllers/base";
import {
  createPropController
} from "../prop-controllers/instances";
import { useStyle } from "../runtimes/react/use-style";
const StyleV2ControlType = "makeswift::controls::style-v2";
const unstable_useStyleV2ClassName = useStyle;
function unstable_StyleV2(config) {
  return { type: StyleV2ControlType, config };
}
const StyleV2ControlMessageType = {
  CHANGE_BOX_MODEL: "makeswift::controls::style::message::change-box-model",
  STYLE_V2_CONTROL_CHILD_CONTROL_MESSAGE: "makeswift::controls::style-v2::message::child-control-message"
};
class StyleV2Control extends PropController {
  control;
  constructor(send, descriptor) {
    super(send);
    this.control = createPropController(descriptor.config.type, (message) => {
      this.send({
        type: StyleV2ControlMessageType.STYLE_V2_CONTROL_CHILD_CONTROL_MESSAGE,
        payload: { message }
      });
    });
  }
  changeBoxModel(boxModel) {
    this.send({ type: StyleV2ControlMessageType.CHANGE_BOX_MODEL, payload: { boxModel } });
  }
  recv(message) {
    switch (message.type) {
      case StyleV2ControlMessageType.STYLE_V2_CONTROL_CHILD_CONTROL_MESSAGE: {
        const control = this.control;
        if (control == null)
          return;
        const recv = control.recv;
        recv(message.payload.message);
      }
    }
  }
}
export {
  StyleV2Control,
  StyleV2ControlMessageType,
  StyleV2ControlType,
  unstable_StyleV2,
  unstable_useStyleV2ClassName
};
//# sourceMappingURL=style-v2.js.map